import React, { useEffect, useState } from 'react';
import useAsync from '../hooks/useAsync';
import UserServices from '../services/UserServices';
import Modal from 'react-modal';
import * as XLSX from 'xlsx';
import { FaRegEye } from "react-icons/fa";
import { Tooltip } from 'react-tooltip'
Modal.setAppElement('#root');
function Vendorsalary() {
  const { data, error, isLoading, run } = useAsync(UserServices.getAllVendor);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const usersPerPage = 20;
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;

  const calculateSalary = (attendance) => {
    const dailyRate = 100;
    return attendance * dailyRate;
  };

  const filteredUsers = (data?.data || []).filter((vendor) => {
    const Name = vendor?.name ? vendor.name.toLowerCase() : '';
    const email = vendor?.email ? vendor.email.toLowerCase() : '';
    const mobileNo = vendor?.mobileNo ? vendor.mobileNo.toString() : '';
    return (
      (Name.includes(searchQuery.toLowerCase()) ||
        email.includes(searchQuery.toLowerCase()) ||
        mobileNo.includes(searchQuery))
    );
  });

  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const generateExcel = () => {
    const filteredData = filteredUsers?.map((vendor) => ({
      name: vendor?.name,
      mobileNo: vendor?.mobileNo,
      attendance: vendor?.attendance,
      salary: calculateSalary(vendor?.attendance),
      date: formatDateTime(vendor?.createdAt)
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Vendor Salary');
    XLSX.writeFile(wb, 'vendor_salary_data.xlsx');
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleStatusChange = (id) => {
    if (id) {
      window.location.href = `/vendor-attendance?id=${id}`;
    }
  };
  return (
    <div className="right_col" role="main">
      <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

        <div className="my-auto">

          <h5 className="page-title fs-21 mb-1">
            Vendor Salary Management
          </h5>
          <nav>

            <ol className="breadcrumb mb-0">

              <li className="breadcrumb-item">
                <a href="javascript:void(0);">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Salary Management
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto gap-2 right-content align-items-center">

          <div className="pe-1 mb-xl-0">
            <button className="excel-btn" onClick={generateExcel}>
              <img src="img/excel.svg" alt="Download Excel" />
              Download
            </button>

          </div>



        </div>
      </div>

      <div className="container-box px-0 user-manager">
        <div className="Tablesearch_design">
          <div className="row">
            <div className='col-md-6'>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <input
                  type="search"
                  name="search"
                  placeholder="Search by Name, Mobile and Email id"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className='form-control'
                />
                <button className="search-btn">Search</button>
              </div>
            </div>
          </div>

        </div>

        <div className="container-box-inner table-reponsive-tabe">
          <table id="example" className="table table-striped" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>#</th>
                <th>NAME</th>
                <th>MOBILE NO.</th>
                <th>ATTENDANCE</th>
                <th>SALARY</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers?.map((vendor, index) => (
                <tr key={vendor?.id || index}>
                  <td>{index + 1 + indexOfFirstUser}</td>
                  <td>{vendor?.name || "N/A"}</td>
                  <td>{vendor?.mobileNo || "N/A"}</td>

                  <td
                    className="view-cities-button"
                    data-tooltip-id="view-cities-tooltip"
                    data-tooltip-content="Attendance View"
                  >
                    <FaRegEye
                      className="custom-icon"
                      onClick={() => handleStatusChange(vendor?._id)} // Use onClick for the icon
                      style={{ cursor: "pointer" }} // Add pointer cursor for better UX
                    />
                    <Tooltip id="view-cities-tooltip" />
                  </td>
                  <td>{vendor?.vendorSalary}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Vendorsalary;